// Sistema de Limite de Peso do Carrinho - Sem dependência do Alpine
(function() {
    'use strict';
    
    // Verificar se está ativado
    if (!window.cartLimitSettings || !window.cartLimitSettings.enable) {
        console.log('Cart weight limit está desativado');
        return;
    }

    console.log('Inicializando cart weight limit...', window.cartLimitSettings);

    // Estado do carrinho
    let currentCart = null;
    let isChecking = false;

    // Buscar carrinho atual
    async function fetchCart() {
        try {
            const response = await fetch('/cart.js');
            const cart = await response.json();
            currentCart = cart;
            return cart;
        } catch (error) {
            console.error('Erro ao buscar carrinho:', error);
            return null;
        }
    }

    // Mostrar popup de limite excedido
    function showWeightLimitPopup(currentWeight) {
        const popup = document.getElementById('cart-weight-limit-popup');
        const messageEl = document.getElementById('cart-weight-limit-message');
        
        if (popup && messageEl) {
            const maxKg = (window.cartLimitSettings.maxWeight / 1000).toFixed(2).replace('.', ',');
            const currentKg = (currentWeight / 1000).toFixed(2).replace('.', ',');
            let message = window.cartLimitSettings.text;
            message = message.replace('[weight]', maxKg).replace('[current_weight]', currentKg);
            messageEl.textContent = message;
            
            popup.style.display = 'flex';
            setTimeout(() => {
                popup.classList.add('opacity-100', 'pointer-events-auto');
            }, 10);
        }
    }

    // Verificar se o peso excede o limite
    function checkWeightLimit(totalWeight) {
        return totalWeight <= window.cartLimitSettings.maxWeight;
    }

    // Interceptar fetch global para pegar chamadas da API do carrinho
    const originalFetch = window.fetch;
    window.fetch = async function(...args) {
        const [url, options] = args;
        
        // Verificar se é uma chamada para a API do carrinho
        const isCartAdd = url.includes('/cart/add');
        const isCart = url.includes('/cart.js');
        const isCartChange = url.includes('/cart/change');
        const isCartUpdate = url.includes('/cart/update');
        
        if (!isCartAdd && !isCartChange && !isCartUpdate && !isCart) {
            // Não é uma operação de carrinho, seguir normalmente
            return originalFetch.apply(this, args);
        }

        // Evitar recursão
        if (isChecking) {
            return originalFetch.apply(this, args);
        }

        console.log('Interceptando chamada de carrinho:', url);

        try {
            isChecking = true;

            // Fazer a operação original
            const response = await originalFetch.apply(this, args);
            
            // Se não foi bem sucedida, retornar sem verificar
            if (!response.ok) {
                isChecking = false;
                return response;
            }

            // Clonar a resposta para poder ler o body
            const clonedResponse = response.clone();
            
            // Aguardar um pouco para o carrinho atualizar
            await new Promise(resolve => setTimeout(resolve, 100));
            
            // Buscar o estado atual do carrinho
            const cart = await fetchCart();

            console.log('Cart visualizado', cart);
            
            if (cart && !checkWeightLimit(cart.total_weight)) {
                console.log('Limite de peso excedido!', cart.total_weight, '>', window.cartLimitSettings.maxWeight);
                
                // Tentar reverter a operação
                try {
                    const bodyData = options && options.body ? JSON.parse(options.body) : null;
                    
                    if (isCartAdd && bodyData) {
                        // Reverter adição
                        const items = bodyData.items || [bodyData];
                        for (const item of items) {
                            const variantId = item.id;
                            const quantity = item.quantity || 1;
                            const cartItem = cart.items.find(i => i.variant_id === variantId);
                            
                            if (cartItem) {
                                const newQty = Math.max(0, cartItem.quantity - quantity);
                                await originalFetch('/cart/change.js', {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify({ id: cartItem.key, quantity: newQty })
                                });
                            }
                        }
                    } else if (isCartChange && bodyData) {
                        // Reverter mudança - buscar quantidade anterior
                        const itemKey = bodyData.id;
                        const oldItem = currentCart ? currentCart.items.find(i => i.key === itemKey || i.variant_id === itemKey) : null;
                        
                        if (oldItem) {
                            await originalFetch('/cart/change.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ id: itemKey, quantity: oldItem.quantity })
                            });
                        }
                    } else if (isCartUpdate && bodyData && bodyData.updates) {
                        // Reverter update
                        const revertUpdates = {};
                        for (const key in bodyData.updates) {
                            const oldItem = currentCart ? currentCart.items.find(i => i.key === key || i.variant_id == key) : null;
                            revertUpdates[key] = oldItem ? oldItem.quantity : 0;
                        }
                        
                        await originalFetch('/cart/update.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ updates: revertUpdates })
                        });
                    }
                    
                    // Atualizar carrinho após reversão
                    await fetchCart();
                    
                    // Disparar evento de atualização do carrinho
                    document.dispatchEvent(new CustomEvent('cart:updated'));
                    
                } catch (revertError) {
                    console.error('Erro ao reverter operação:', revertError);
                }
                
                // Mostrar popup
                showWeightLimitPopup(cart.total_weight);
                
                isChecking = false;
                
                // Retornar uma resposta de erro
                return new Response(
                    JSON.stringify({ 
                        status: 422, 
                        message: 'Limite de peso excedido',
                        description: window.cartLimitSettings.text.replace('[weight]', (window.cartLimitSettings.maxWeight / 1000).toFixed(2).replace('.', ',')) 
                    }), 
                    { 
                        status: 422, 
                        headers: { 'Content-Type': 'application/json' } 
                    }
                );
            }

            isChecking = false;
            return response;
            
        } catch (error) {
            console.error('Erro na verificação de peso:', error);
            isChecking = false;
            return originalFetch.apply(this, args);
        }
    };

    // Inicializar carrinho
    fetchCart().then(cart => {
        console.log('Carrinho inicial carregado:', cart ? `${cart.item_count} items, ${cart.total_weight}g` : 'vazio');
    });

    // Listener para eventos de atualização do carrinho
    document.addEventListener('cart:updated', () => {
        console.log('Cart updated event - fetching new cart state');
        fetchCart();
    });
    
    document.addEventListener('cart-change', () => {
        console.log('Cart change event - fetching new cart state');
        fetchCart();
    });

    console.log('Cart weight limit inicializado com sucesso!');
})();
